import Model, { attr, belongsTo } from '@ember-data/model';

export default class Collection extends Model {
  @attr('string')
  numAdmissionsListItems;

  @belongsTo('school', { async: true, inverse: 'collection' })
  school;
}
